/**
 * DEPRECATED
 * This component was built originally for uncontrolled forms but now we are moving towards
 * controlled forms because they are a more common React pattern. For more info check the link.
 * Alternative:
 * Use components in bench-internal-theme/form-input-fields. If this component doesn't exist, make a
 * copy and refactor so it can be used in a controlled form.
 * @link https://benchco.atlassian.net/browse/IN-2122?utm_medium=referral-external&utm_source=jira-slack&utm_term=
 */
import { colors } from 'bench-style-constants';
import styled from 'styled-components';

const TextareaInput = styled.textarea`
  border: 1px solid ${colors.stone};
  border-radius: 2px;
  // "width: 100%" combined with horizontal padding or borders requires "box-sizing: border-box" to
  // prevent horizontal overflow
  box-sizing: border-box;
  color: #3a3b40;
  font-size: 12px;
  min-height: 32px;
  padding: 12px;
  resize: none;
  width: 100%;

  &::placeholder {
    color: #a7a6a5;
  }

  &:disabled {
    background: ${colors.sand};
    border-color: ${colors.sand};
    color: ${colors.dust};
  }
`;

export default TextareaInput;
